import { buildActionNames } from 'modules/store/util';

const moduleName = 'account';

// Action Types
export const types = buildActionNames(moduleName, [
  'ERROR_SET',
  'INVITE_FINALIZE',
  'INVITE_FINALIZED_SET',
  'INVITE_GET',
  'INVITE_SET',
  'TERMS_GET',
  'TERMS_SET',
  'VERIFICATION_SUBMIT',
  'VERIFICATION_SUCCESS_LOG',
]);

// Initial state
export const initialState = {
  captchaSiteKey: '',
  emailAddress: '',
  error: {
    alreadyRegistered: false,
    inviteExpired: false,
    terms: false,
  },
  firstName: '',
  inviteFinalized: false,
  inviteToken: '',
  isVerified: false,
  lastName: '',
  loaded: {
    invite: false,
    terms: false,
  },
  securityQuestions: [],
  terms: '',
  validationToken: '',
};

// Action Creators
const finalizeInvite = ({ password, securityQuestion, securityAnswer }) => ({
  type: types.INVITE_FINALIZE,
  payload: { password, securityQuestion, securityAnswer },
});

const getInvite = ({ inviteToken }) => ({
  type: types.INVITE_GET,
  payload: { inviteToken },
});

const getTerms = () => ({
  type: types.TERMS_GET,
});

const logVerificationSuccess = ({
  emailAddress,
  securityQuestions,
  validationToken,
}) => ({
  type: types.VERIFICATION_SUCCESS_LOG,
  payload: {
    emailAddress,
    isVerified: true,
    securityQuestions,
    validationToken,
  },
});

const setAccountError = (errorKey) => ({
  type: types.ERROR_SET,
  payload: {
    [errorKey]: true,
  },
  error: true,
});

const setInvite = ({
  captchaSiteKey,
  firstName,
  lastName,
  validationToken,
}) => ({
  type: types.INVITE_SET,
  payload: { captchaSiteKey, firstName, lastName, validationToken },
});

const setInviteFinalized = () => ({
  type: types.INVITE_FINALIZED_SET,
  payload: {
    inviteFinalized: true,
  },
});

const setTerms = ({ terms }) => ({
  type: types.TERMS_SET,
  payload: {
    terms,
  },
});

const submitVerification = ({ captchaToken, zipCode }) => ({
  type: types.VERIFICATION_SUBMIT,
  payload: {
    captchaToken,
    zipCode,
  },
});

export const actions = {
  finalizeInvite,
  getInvite,
  getTerms,
  logVerificationSuccess,
  setAccountError,
  setInvite,
  setInviteFinalized,
  setTerms,
  submitVerification,
};

// Reducers
const accountReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case types.INVITE_FINALIZE:
    case types.INVITE_FINALIZED_SET:
    case types.INVITE_GET:
    case types.VERIFICATION_SUCCESS_LOG:
    case types.VERIFICATION_SUBMIT:
      return {
        ...state,
        ...action.payload,
      };
    case types.ERROR_SET:
      return {
        ...state,
        error: {
          ...state.error,
          ...action.payload,
        },
      };
    case types.INVITE_SET:
      return {
        ...state,
        loaded: {
          ...state.loaded,
          invite: true,
        },
        ...action.payload,
      };
    case types.TERMS_SET:
      return {
        ...state,
        loaded: {
          ...state.loaded,
          terms: true,
        },
        ...action.payload,
      };
    default:
      return state;
  }
};

export default accountReducer;
